import {getConfigFields, getMaxLengthConstraint, getNotNullConstraint, getPatternConstraint} from '../fields.js'
import {formFieldIds, PATTERN_CONSTRAINT_MIN_PRICE_150} from '../values.js'

const {adTitle, comments, hidePhone, price} = formFieldIds

export const formPublishAdMinibikeFormConfig = {
  fields: [
    getConfigFields[adTitle](),
    getConfigFields[price]({
      customProps: {
        help: 'PUBLISH_AD.FB.PRIZES.MINIBIKE.HELP',
        hint: 'PUBLISH_AD.FB.PRIZES.HINT',
        constraints: [
          getNotNullConstraint({
            message: 'PUBLISH_AD.FB.PRIZES.MOTOS.CONSTRAINTS.NOTNULL'
          }),
          getPatternConstraint({
            message: 'PUBLISH_AD.FB.PRIZES.MINIBIKE.CONSTRAINTS.MIN',
            pattern: PATTERN_CONSTRAINT_MIN_PRICE_150
          }),
          getMaxLengthConstraint({value: 7})
        ]
      }
    })
  ],
  initialValues: {
    [adTitle]: '',
    [comments]: '',
    [hidePhone]: true,
    [price]: ''
  },
  lockedFieldsOnEdition: [adTitle],
  remotes: [],
  rules: {}
}
